import About from "components/About";
import Gallery from "components/common/Gallery";
import Contact from "components/Contact";
import ContactForm from "components/ContactForm";
import Footer from "components/Footer";
import Header from "components/header";
import PathShow from "components/PathShow";
import Reveal from "motion/Reveal";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const [t] = useTranslation("global");

  return (
    <>
      <div className="font-[Yekan] mt-[99px] md:mt-[83px] bg-gray-100">
        <Header />
        <div className="max-w-4xl mx-auto p-6">
          <ContactForm />
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
